import { Component } from '@angular/core';
import { BaseComponent } from "src/app/components/base.component";
import { Store } from "@ngrx/store";
import { currentDocumentView } from "@store/doc-viewer/document-view/document-view.selectors";

@Component({
    selector: 'lex-doc-viewer-content',
    templateUrl: './doc-viewer-content.component.html',
    styleUrls: ['./doc-viewer-content.component.scss'],
    standalone: false
})
export class DocViewerContentComponent extends BaseComponent {
	public currentDocumentView$ = this.store.select(currentDocumentView());

	constructor(
		private store: Store
	) {
		super();
	}
}
